import React, { useState, useEffect, useContext, useRef } from 'react';

import APIService from '../../shared/services/api';

import Notify from '../../shared/notify';

import TextInput from '@shared/component/TextInput';
import { AuthContext } from '@shared/context/AuthContext';

import moment from 'moment';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { NavLink } from 'react-router-dom';
import DropDown from '@shared/component/DropDown';
import CheckValidator from '@shared/checkValidator';
import MultiSelect from '@shared/component/MultiSelect';
import CustomDateTimePicker from '@shared/component/DatePicker';
import { useLocalStorage } from '@shared/auth/useLocalStorage';
import { ActionValues, DateFormatPicker, actionsPermissionValidator, imageCompress } from '@utils/static/commonUtils';
import Lists from '@shared/component/Lists';

export function Demand_other() {
    const childRef: any = useRef(null);
    const itemRef: any = useRef(null);
    // const date = new Date();
    // const newDate24 = date.setTime(date.getTime() + 2 * 60 * 60 * 1000);
    // const newDate48 = date.setTime(date.getTime() + 4 * 60 * 60 * 1000);
    const date = new Date();
    const newDate24 = new Date(date);
    const newDate48 = new Date(newDate24);
    const newDate72 = new Date(newDate48);

    newDate24.setTime(date.getTime() + 2 * 60 * 60 * 1000);
    newDate48.setTime(date.getTime() + 4 * 60 * 60 * 1000);
    newDate72.setTime(date.getTime() + 6 * 60 * 60 * 1000);

    const [errors, setError] = useState<any>({
        bidType: {
            required: false,
            error: false,
        },
        categoryId: {
            required: true,
            error: true,
            message: 'Please select category',
        },
        itemId: {
            required: true,
            error: true,
            message: 'Please select Item',
        },
        deliveryDate: {
            required: true,
            error: true,
            message: 'Please select date',
            min: newDate48,
        },
        cutOffTime: {
            required: true,
            error: true,
            message: 'Please select date',
            min: newDate24,
        },
        itemUnit: {
            required: true,
            error: true,
            message: 'Please select unit    ',
        },
        minBidRate: {
            required: true,
            error: true,
            message: 'Please enter min bid',
            pattern: /^(?=.*[1-9])\d*(?:\.\d{1,})?$/,
            maxLength: 5,
        },
        maxBidRate: {
            required: true,
            error: true,
            message: 'Please enter max bid',
            pattern: /^(?=.*[1-9])\d*(?:\.\d{1,})?$/,
            maxLength: 5,
        },
        quantity: {
            required: true,
            error: true,
            message: 'Please enter quantity',
            pattern: /^(?=.*[1-9])\d*(?:\.\d{1,})?$/,
            maxLength: 5,
        },
        quality: {
            required: true,
            error: true,
            message: 'Please enter quality',
            pattern: /^[A-Za-z\s]*$/,
            maxLength: 20,
        },
        description: {
            required: false,
            error: false,
            message: 'Please enter description',
        },
        userIds: {
            required: true,
            error: true,
            message: 'Please select user',
        },
    });
    const listRef: any = useRef(null);
    const { getStorageItem }: any = useLocalStorage();
    const user = getStorageItem('user') ? JSON.parse(getStorageItem('user')) : false;

    const { setLoader, demandStatus }: any = useContext(AuthContext);
    const [Demand_other, setDemand_other] = useState([]);
    const [id, setId] = useState(null);
    const [statusCompleted, setStatusCompleted] = useState('');
    const [recordCount, setRecordCount] = useState(0);
    const [categories, setCategories] = useState([]);
    const [items, setitems] = useState([]);
    const [itemtype, setItemType] = useState('');
    const [vendor, setVendor] = useState([]);
    const [minBidError, setminBidError] = useState(false);
    const [showList, setShowList] = useState(false);
    const [disabledDeliveryDate, setDisabledDeliveryDate] = useState(true);
    const [firstRender, setFirstRender] = useState(false);

    const [unit, setunit] = useState([
        {
            name: 'mass',
            data: ['Milligram', 'Gram', 'Pound', 'Kilogram', 'Metric Ton'],
        },
        {
            name: 'volume',
            data: ['Milliliter', 'Litre', 'Cubic Meter'],
        },
        {
            name: 'length',
            data: ['Millimeter', 'Inch', 'Feet', 'Meter', 'Kilometer', 'Mile'],
        },
        {
            name: 'energy',
            data: ['Watt', 'Kilowatt', 'Megawatt', 'Gigawatt', 'Milliwatt'],
        },
        {
            name: 'pieces',
            data: ['Number'],
        },
    ]);

    const [isSubmit, setIsSubmit] = useState(false);
    const [formData, setFormData] = useState<any>({
        categoryId: null,
        deliveryDate: null,
        userIds: [],
        bidType: null,
        itemId: null,
        itemUnit: null,
        minBidRate: null,
        quantity: null,
        maxBidRate: null,
        cutOffTime: null,
        quality: null,
        description: '',
        categoryData: {},
        sample: '',
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [showHideModel, setShowHideModel] = useState(false);
    const [edit, setEdit] = useState(false);
    const [forceRender, setForceRender] = useState(false);
    const [appUserList, setAppUserList] = useState([]);

    const [columns, setColumns] = useState({
        id: 'Demand Id',
        bidType: 'Demand Type',
        app_users: 'Vendor Name',
        'category.name': 'Category',
        'item.name': 'Item',
        quantity: 'Quantity',
        itemUnit: 'Unit',
        deliveryDate: 'Delivery Date & Time',
        createdAt: 'Created Date',
        status: 'Status',
        // demandOtherAction: 'Action',
        ...(actionsPermissionValidator(location.pathname, ActionValues.Edit) ||
            actionsPermissionValidator(location.pathname, ActionValues.View) ||
            actionsPermissionValidator('/home/bids/other', ActionValues.View)
            ? { demandOtherAction: 'Action' }
            : null),
    });

    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
            setIsSubmit(false);
        } catch (error) { }
    };

    const handleShowList = data => {
        setAppUserList(data);
        setShowList(true);
    };

    //transform api data for table use
    const getTransformedData = data => {
        const transformedata = data?.map(item => ({
            id: item.id,
            demandType: item.bidType ? item.bidType : '-',
            category: item.category?.name ? item.category?.name : '-',
            items: item?.item?.name ? item?.item?.name : '-',
            quantity: item?.quantity ? item?.quantity : '-',
            unit: item?.itemUnit ? item?.itemUnit : '-',
            deliveryDateTime: item?.deliveryDate ? DateFormatPicker(item.deliveryDate, 'DD-MMM-YYYY hh:mm A') : '-',
            status: item?.status ? (
                <>
                    {item.status === 'completed' ? (
                        <span className="text-center text-secondary">Completed</span>
                    ) : (
                        <div
                            className={
                                item.status === 'active'
                                    ? 'dropdown dropdown_status_box'
                                    : 'dropdown dropdown_status_box inactive_status_box'
                            }
                        >
                            <button
                                className="btn btn-secondary dropdown-toggle capitalize"
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {item?.status}
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li>
                                    <a
                                        className={item.status === 'active' ? 'dropdown-item active' : 'dropdown-item'}
                                        href="javascript:void(0)"
                                        onClick={() => {
                                            updateStatus(item, 'active', item.id, page);
                                        }}
                                    >
                                        Active
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className={item.status === 'active' ? 'dropdown-item ' : 'dropdown-item active'}
                                        href="javascript:void(0)"
                                        onClick={() => {
                                            updateStatus(item, 'inactive', item.id, page);
                                        }}
                                    >
                                        Inactive
                                    </a>
                                </li>
                            </ul>
                        </div>
                    )}
                </>
            ) : (
                '-'
            ),
            action: (
                <>
                    <>
                        {item.status !== 'completed' &&
                            actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                            <a
                                className="btn blue_btn custom_btn"
                                href="javascript:void(0)"
                                onClick={() => {
                                    getDemand_otherById(item.id);
                                }}
                            >
                                <img className="img-fluid" src="assets/images/edit.svg" alt="" /> Edit
                            </a>
                        ) : (
                            <>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </>
                        )}
                    </>
                    <>
                        &nbsp;
                        <NavLink
                            to={`/home/bids/others/${item.id}/${item?.item?.name}`}
                            className="btn bidsblue_btn custom_btn"
                        >
                            <img className="img-fluid " style={{ width: '18px' }} src="assets/images/bids.png" alt="" />{' '}
                            Bids
                        </NavLink>
                    </>
                </>
            ),
        }));
        return transformedata;
    };

    const searchItem = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            let data;
            if (value) {
                data = await APIService.getAll(
                    `demand/oth/search/get?page=${page}&order=desc&sort=createdAt&search=${value}`,
                    true,
                    false,
                );
            } else {
                data = await APIService.getAll(`demand/oth/get?page=${page}&sort=createdAt`, true, false);
            }

            setLoader(false);
            setDemand_other(data.data.data);
            setRecordCount(data?.data?.count || 0);
        } catch (err) {
            setLoader(false);
        }
    };

    const getDemand_other = async (page: any = 1) => {
        try {
            setCurrentPage(page);
            setLoader(true);
            const data = await APIService.getAll(`demand/oth/get?page=${page}&sort=createdAt`, true, false);
            setDemand_other(data?.data?.data || []);
            setLoader(false);
            setRecordCount(data?.data?.count || 0);
        } catch (err) {
            setLoader(false);
        }
    };

    const getValue = (e: any) => {
        try {
            if (e.categoryId === null) {
                setFormData((pre: any) => ({ ...pre, userIds: [] }));
                setitems([]);
                setVendor([]);
            }
            const minBid = formData?.minBidRate;
            if (isSubmit && e?.maxBidRate && minBid && parseInt(e?.maxBidRate) > parseInt(minBid)) {
                setminBidError(false);
            }
            if (e.cutOffTime) {
                setDisabledDeliveryDate(false);
            }
            const data = { ...formData, ...e };

            // Handle Cutoff make delivery empty after first render
            if ('cutOffTime' in e) {
                if (formData['deliveryDate'] && firstRender && edit) {
                    setFormData({ ...data, deliveryDate: null });
                    return;
                }
            }
            setFormData(data);
        } catch (error) { }
    };
    // const resetItemUnit = () => {
    //     const data = { ...formData, itemUnit: null };
    //     setFormData(data);
    // };

    const getCategory = async () => {
        try {
            setLoader(true);
            const apiUrl = `category/all/nolimit?type=active`;
            const data = await APIService.getAll(apiUrl, true, false);
            setLoader(false);
            setCategories(data.data.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const getitems = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll('items/all/get?sort=createdAt&type=active', true, false);
            setLoader(false);
            setitems(data.data.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const getVendor = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll('user/get/allOtherAppUser?type=active', true, false);
            setLoader(false);
            setVendor(data.data.data);
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getDemand_other();
        getCategory();
        // getitems();
        // getVendor();
        handlereset();
    }, []);

    const updateDemand = () => {
        getDemand_other();
    };
    useEffect(() => {
        if (demandStatus === 'others') {
            updateDemand();
        }
    }, [demandStatus]);

    const getUserByCategory = async id => {
        try {
            setLoader(true);
            const data = await APIService.getAll(`category/getUserByCategory/${id}`, true, false);

            const vendor = (data?.data?.data?.app_users || []).filter(i => i.items?.length == 0);
            // setVendor(vendor || []);
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    const addDemand_other = async () => {
        try {
            let isValid = await CheckValidator(errors, formData);
            if (
                formData?.minBidRate &&
                formData?.maxBidRate &&
                parseInt(formData?.minBidRate) > parseInt(formData?.maxBidRate)
            ) {
                isValid = false;
                setminBidError(true);
            } else {
                setminBidError(false);
            }

            setIsSubmit(!isValid);

            if (isValid) {
                const delivery = moment(new Date(formData.deliveryDate));
                const cutOff = moment(new Date(formData.cutOffTime));

                if (delivery.diff(cutOff, 'hour') < 2) {
                    Notify('error', 'Delivery time at least two hours greater than cut Off time');
                    return;
                }
                if (formData.categoryId == null && formData.categoryId == '') {
                    Notify('error', 'Please select category');
                    return;
                } else {
                    const data = {
                        categoryId: formData.categoryId,
                        deliveryDate: formData.deliveryDate,
                        userIds: JSON.stringify(formData.userIds),
                        bidType: formData.bidType,
                        itemId: formData.itemId,
                        itemUnit: formData.itemUnit,
                        minBidRate: formData.minBidRate,
                        quantity: formData.quantity,
                        maxBidRate: formData.maxBidRate,
                        cutOffTime: formData.cutOffTime,
                        quality: formData.quality,
                        sample: formData.file !== undefined ? formData.file : '',
                    };

                    if (formData?.description) {
                        data['description'] = formData?.description;
                    }

                    setLoader(true);
                    const updateddata = await APIService.post('demand/oth', data, true, true);
                    setLoader(false);
                    if (updateddata.status === 200) {
                        Notify('success', 'Demand  created successfully');
                        setEdit(false);
                        handelModel(false);
                        setFormData({
                            ['bidType']: 'manual',
                            ['categoryId']: null,
                            ['itemId']: null,
                            ['quantity']: null,
                            ['quality']: null,
                            ['itemUnit']: null,
                            ['userIds']: [],
                            ['deliveryDate']: null,
                            ['minBidRate']: null,
                            ['maxBidRate']: null,
                            ['cutOffTime']: null,
                            ['description']: null,
                        });

                        setItemType('');

                        getDemand_other();
                        listRef.current.clearSearchBox();
                    }
                    setLoader(false);
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const updateStatus = async (item: any, status: any, id: any, page: any, search: any) => {
        try {
            const data = {
                status: status,
            };
            setLoader(true);
            const updateddata = await APIService.update('demand/othDemadStatus', id, data, true, true);
            setLoader(false);
            if (updateddata.status === 200) {
                Notify('success', 'Demand  status updated successfully');
                searchItem(search.trim(), page);
            }
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    const updateDemand_other = async () => {
        try {
            let isValid = await CheckValidator(errors, formData);
            if (
                formData?.minBidRate &&
                formData?.maxBidRate &&
                parseInt(formData?.minBidRate) > parseInt(formData?.maxBidRate)
            ) {
                isValid = false;
                setminBidError(true);
            } else {
                setminBidError(false);
            }
            setIsSubmit(!isValid);
            if (isValid) {
                // if (formData.cutOffTime && new Date(formData.cutOffTime).getTime() < newDate24.getTime()) {
                //     Notify('error', 'Please select a cutoff date that is at least two hours in the future');
                //     return;
                // }
                // if (formData.deliveryDate && new Date(formData.deliveryDate).getTime() < newDate48.getTime()) {
                //     Notify('error', 'Please select a delivery date that is at least four hours in the future');
                //     return;
                // }
                const delivery = moment(new Date(formData.deliveryDate));
                const cutOff = moment(new Date(formData.cutOffTime));

                if (delivery.diff(cutOff, 'hour') < 2) {
                    Notify('error', 'delivery date least two hours greater  than cutOff time');
                    return;
                }
                if (formData.categoryId == null && formData.categoryId == '') {
                    Notify('error', 'Please select category');
                    return;
                } else {
                    const data = {
                        categoryId: formData.categoryId,
                        deliveryDate: formData.deliveryDate,
                        userIds: JSON.stringify(formData.userIds),
                        bidType: formData.bidType,
                        itemId: formData.itemId,
                        itemUnit: formData.itemUnit,
                        minBidRate: formData.minBidRate,
                        quantity: formData.quantity,
                        maxBidRate: formData.maxBidRate,
                        cutOffTime: formData.cutOffTime,
                        quality: formData.quality,
                        description: formData.description,
                        sample: formData.file !== undefined ? formData.file : '',
                        demandId: id,
                    };
                    setLoader(true);
                    const updateddata = await APIService.update('demand/oth', '', data, true, true);
                    setLoader(false);
                    if (updateddata.status === 200) {
                        Notify('success', 'Demand updated successfully');
                        setEdit(false);
                        handelModel(false);
                        setFormData({
                            ['bidType']: 'manual',
                            ['categoryId']: null,
                            ['itemId']: null,
                            ['quantity']: null,
                            ['quality']: null,
                            ['itemUnit']: null,
                            ['userIds']: [],
                            ['deliveryDate']: null,

                            ['minBidRate']: null,
                            ['maxBidRate']: null,
                            ['cutOffTime']: null,
                            ['description']: null,
                        });

                        setItemType('');
                        getDemand_other(currentPage);
                        listRef.current.clearSearchBox(true);
                    }
                }
            }
        } catch (err) {
            setLoader(false);
            console.log(err, 'err');
        }
    };

    const getDemand_otherById = async (id: any) => {
        try {
            setLoader(true);
            const updateddata = await APIService.getById('demand/oth', id, true, false);
            setLoader(false);
            if (updateddata.status === 200) {
                const d = updateddata.data.getAllData[0];
                const data = JSON.parse(JSON.stringify(d));
                if (data) {
                    // console.log('data', data)

                    setStatusCompleted(data?.status);

                    if (data?.status == 'completed') {
                        enableDisableField(true);
                    }

                    setItems(data['categoryId']);
                    setId(data.id);
                    // handleItem(data?.item?.type);
                    setItemType(data.item.type);
                    const appUsers = (data?.app_users || []).filter(i => (i['isFixed'] = true));
                    // Handle use length validation
                    if (appUsers.length) errors['userIds']['error'] = false;
                    // convertDateTime(data, 'deliveryDate', 330);
                    // convertDateTime(data, 'cutOffTime', 330);

                    const check = categories.find((category: any) => data.categoryId === category.id);
                    setitems(check?.items || []);

                    const check2 = [...(check?.items || [])].find((items: any) => items.id === data.itemId);

                    setVendor(check2?.app_users || []);

                    setFormData({
                        ['bidType']: data.bidType,
                        ['categoryId']: data.categoryId,
                        ['itemId']: data.itemId,
                        ['quantity']: data.quantity,
                        ['quality']: data.quality,
                        ['itemUnit']: data.itemUnit,
                        ['userIds']: appUsers,
                        ['deliveryDate']: data.deliveryDate,
                        ['filename']: data.sampleId,
                        ['minBidRate']: data.minBidRate,
                        ['maxBidRate']: data.maxBidRate,
                        ['cutOffTime']: data.cutOffTime,
                        ['description']: data.description,
                        categoryData: { label: data?.category?.name || '', value: data?.categoryId || 0 },
                        itemData: { label: data?.item?.name || '', value: data?.item?.id || 0 },
                        ['imageUrl']:
                            data.sampleId != null
                                ? data.sampleId.split('.')[1] == 'jpeg' ||
                                    data.sampleId.split('.')[1] == 'jpg' ||
                                    data.sampleId.split('.')[1] == 'png'
                                    ? process.env.REACT_APP_API_BASE + data.sampleId
                                    : 'pdf'
                                : null,
                    });
                    setEdit(true);
                    handelModel(true);

                    // For next cycle
                    setTimeout(() => {
                        setFirstRender(true);
                    }, 500);
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const handlevendor = (data: any) => {
        const d = data.map((i: any) => {
            return { id: i.id, name: i.name };
        });
        setFormData({ ...formData, ['userIds']: d });
    };

    const enableDisableField = flag => {
        try {
            errors['maxBidRate']['disabled'] = flag;
            errors['minBidRate']['disabled'] = flag;
            errors['itemUnit']['disabled'] = flag;
            errors['description']['disabled'] = flag;
            errors['quality']['disabled'] = flag;
            errors['quantity']['disabled'] = flag;

            setError(errors);
        } catch (error) { }
    };

    const handlefile = async (files: FileList | null, e: any) => {
        if (files && files.length > 0) {
            const fileObj = files[0];

            // Check file size (3MB limit)
            const maxSize = 5 * 1024 * 1024; // 3MB in bytes
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
            if (!allowedTypes.includes(fileObj.type)) {
                Notify('error', 'Invalid file format. Please choose a JPG, JPEG, PNG, or PDF file.');
                e.target.value = null;
                return;
            }
            if (fileObj.size > maxSize) {
                Notify('error', 'File size must be less than 5 mb.');
                e.target.value = null;
                return;
            }

            const file: any = await imageCompress(fileObj);

            // Handle the file based on its type
            if (file.type.startsWith('image/')) {
                // If it's an image, update the preview
                const reader = new FileReader();
                reader.onload = (e: ProgressEvent<FileReader>) => {
                    setFormData({
                        ...formData,
                        file: file,
                        filename: file.name,
                        imageUrl: e.target?.result as string,
                    });
                };
                reader.readAsDataURL(file);
            } else {
                // If it's not an image, handle it accordingly
                setFormData({
                    ...formData,
                    file: file,
                    filename: file.name,
                    imageUrl: 'pdf',
                });
            }
        }
    };

    const handlereset = () => {
        setEdit(false);
        setFormData({
            ['bidType']: 'manual',
            ['categoryId']: null,
            ['itemId']: null,
            ['quantity']: null,
            ['quality']: null,
            ['itemUnit']: null,
            ['userIds']: [],
            ['deliveryDate']: null,
            ['imageUrl']: null,

            ['minBidRate']: null,
            ['maxBidRate']: null,
            ['cutOffTime']: null,
            ['description']: '',
        });
        setitems([]);
        setVendor([]);
        handelModel(false);
        setFirstRender(false);
        setDisabledDeliveryDate(true);
    };

    const getDeleteIds = async (ids: any) => {
        try {
            const data: any = {
                ids: JSON.stringify(ids),
            };

            setLoader(true);
            const updateddata = await APIService.post('demand/oth/ids', data, true, true);
            setLoader(false);
            // const updatedData = await axios.put(`${localhost}user/delete/webuser`, data);
            Notify('success', 'Demand  deleted successfully');
            getDemand_other();
        } catch (error) {
            setLoader(false);
        }
    };

    const getMultiSelectValue = (e: any) => {
        try {
            getValue({ userIds: e });
            errors['userIds']['error'] = false;
            setError(errors);
        } catch (error) { }
    };
    const bulkUpload = (e: any) => {
        try {
        } catch (error) { }
    };

    // Update this state variable when errors change
    useEffect(() => {
        setForceRender(prev => !prev);
    }, [errors['itemId']['error']]);

    const setItems = categoryId => {
        try {
            const [data]: any = categories.filter((data: any) => data.id === parseInt(categoryId));
            setitems(data?.['items']?.length > 0 ? data['items'] : []);
        } catch (error) { }
    };

    // const filterPassedTime = time => {
    //     const currentDate = new Date();
    //     const selectedDate = new Date(time);

    //     // Add 2 hours (2 * 60 * 60 * 1000 milliseconds) to the current time
    //     const twoHoursLater = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);

    //     return twoHoursLater.getTime() < selectedDate.getTime();
    // };

    const filterPassedTime = (time, type) => {
        try {
            const cdate = moment();
            const selectedDate = new Date(time);
            const cutOffDate = moment();

            // const pickUpDate = moment(demandDetail?.pickUpDate);

            // if (
            //     cutOffDate.isBefore(cdate) &&
            //     deliveryDate.isBefore(cdate) &&
            //     pickUpDate.isBefore(cdate) &&
            //     type == 'arrive_date'
            // ) {
            //     const currentDate = new Date(demandDetail?.cutOffTime);
            //     return currentDate.getTime() < selectedDate.getTime();
            // }
            const currentDate = new Date();
            if (type == 'cutoff_date') {
                const selectedDate = new Date(time);
                // Add 2 hours (2 * 60 * 60 * 1000 milliseconds) to the current time
                const twoHoursLater = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
                return twoHoursLater.getTime() < selectedDate.getTime();
            } else if (type == 'delivery_date') {
                const currentDate = new Date(formData?.cutOffTime);
                const twoHoursLater = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
                return twoHoursLater.getTime() < selectedDate.getTime();
            }
        } catch (error) { }
    };

    // filter delivery date
    const filterDeliveryTime = (cutOffTime, deliveryTime) => {
        const pickUpDate = new Date(cutOffTime);
        const selectedDeliveryDate = new Date(deliveryTime);

        // Add 2 hours to the pickUpDate
        const twoHoursAfterPickUp = new Date(pickUpDate.getTime() + 2 * 60 * 60 * 1000);

        return twoHoursAfterPickUp.getTime() < selectedDeliveryDate.getTime();
    };

    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>
                            <NavLink to="/home/others">Manage Demands</NavLink>
                        </li>
                        <li>Others</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    <Lists
                        ref={listRef}
                        headers={columns}
                        data={Demand_other}
                        searchItem={searchItem}
                        type={'add+delete'}
                        from={'others'}
                        getDeleteIds={getDeleteIds}
                        updateStatus={updateStatus}
                        getById={getDemand_otherById}
                        addUpdateText="Demand"
                        handelModel={(e: boolean) => handelModel(e)}
                        bulkUpload={(e: boolean) => bulkUpload(e)}
                        categoryData={categories}
                        sendData={data => handleShowList(data)}
                        callPagination={getDemand_other}
                        recordCount={recordCount}
                        helperText={'Search By City, BidType, Demand Id'}
                    />
                </div>
            </div>

            {showList && (
                <Modal scrollable={true} show={true} backdrop="static" keyboard={false}>
                    <Modal.Header closeButton onClick={() => setShowList(false)}>
                        <Modal.Title>Vendor Name</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="model">
                            <div className="text_box">
                                <p style={{ textTransform: 'capitalize' }}>
                                    {appUserList.map(person => person.name).join(', ')}
                                </p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
            )}

            {showHideModel && (
                <Modal
                    scrollable={true}
                    show={true}
                    // onHide={() => handlereset()}
                    onHide={() => {
                        try {
                            handlereset();
                            setStatusCompleted('');
                            enableDisableField(false);
                        } catch (error) { }
                    }}
                    backdrop="static"
                    size="lg"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {' '}
                            {statusCompleted == 'completed' ? 'View Demand' : edit ? 'Update Demand' : 'Add Demand'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="material_form_cover">
                            <form
                                onSubmit={e => {
                                    e.preventDefault();
                                }}
                            >
                                {user?.demandType == 'both' && (
                                    <>
                                        <div className="field_box">
                                            <h3>Bidding Type</h3>
                                            <div className="check_field_box mb-4">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="flexRadioDefault"
                                                        id="flexRadioDefault1"
                                                        value={'auto'}
                                                        onChange={e => {
                                                            setFormData({ ...formData, ['bidType']: e.target.value });
                                                        }}
                                                        checked={formData.bidType === 'auto' ? true : false}
                                                        disabled={statusCompleted == 'completed'}
                                                    />
                                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                        Auto
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="flexRadioDefault"
                                                        id="flexRadioDefault2"
                                                        value={'manual'}
                                                        onChange={e => {
                                                            setFormData({ ...formData, ['bidType']: e.target.value });
                                                        }}
                                                        checked={formData.bidType === 'manual' ? true : false}
                                                        disabled={statusCompleted == 'completed'}
                                                    />
                                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                                        Manual
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <br></br>
                                    </>
                                )}
                                <div className="field_box">
                                    <h3>Items & Vendor Details</h3>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <MultiSelect
                                                isDisabled={statusCompleted == 'completed'}
                                                isSingle={true}
                                                options={categories}
                                                placeholder={'Select Category*'}
                                                getMultiSelectValue={(e: any) => {
                                                    // getValue(e);
                                                    if (e?.value) {
                                                        const check = categories.find(
                                                            (category: any) => category.id === e.value,
                                                        );

                                                        setitems(check?.items || []);

                                                        setVendor([]);

                                                        // getValue({ categoryId: e.value });
                                                        formData['categoryId'] = e.value;
                                                        setFormData(formData);
                                                        errors['categoryId']['error'] = false;
                                                        setError(errors);
                                                    } else {
                                                        getValue({ categoryId: null, itemId: null, userIds: [] });
                                                        setItems([]);
                                                        setVendor([]);
                                                        errors['categoryId']['error'] = true;
                                                        setError(errors);
                                                    }
                                                    itemRef.current.clearDropdown();
                                                    childRef.current.clearDropdown();
                                                }}
                                                displayName="name"
                                                displayValue="id"
                                                // isDisabled={statusCompleted == 'completed' ? true : false}
                                                isClearable={edit ? false : true}
                                                setSelectedValues={formData?.categoryData || null}
                                            />

                                            {errors?.categoryId?.required && errors?.categoryId?.error && isSubmit && (
                                                <div className="text-danger ft-12 error-msg">
                                                    {' '}
                                                    {errors?.categoryId.message}
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-sm-6">
                                            <MultiSelect
                                                isDisabled={statusCompleted == 'completed'}
                                                ref={itemRef}
                                                isSingle={true}
                                                options={items}
                                                placeholder={'Select Items*'}
                                                getMultiSelectValue={(e: any) => {
                                                    // getValue(e);
                                                    if (e?.value) {
                                                        getValue({ itemId: e.value });
                                                        const check = items.find((items: any) => items.id === e.value);

                                                        setVendor(check?.app_users || []);
                                                        if (check?.type) {
                                                            setItemType(check?.type);
                                                        }
                                                        errors['itemId']['error'] = false;
                                                        setError(errors);
                                                    } else {
                                                        errors['itemId']['error'] = true;
                                                        setError(errors);
                                                    }
                                                }}
                                                displayName="name"
                                                displayValue="id"
                                                isClearable={edit ? false : true}
                                                setSelectedValues={formData?.itemData || null}
                                            />

                                            {errors?.itemId?.required && errors?.itemId?.error && isSubmit && (
                                                <div className="text-danger ft-12 error-msg">
                                                    {' '}
                                                    {errors?.itemId.message}
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: 'Enter Required Quantity',
                                                        name: 'quantity',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="quantity"
                                                    isSubmit={isSubmit}
                                                    value={formData.quantity}
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.quantity.message}
                                                    inputProps={errors}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <DropDown
                                                data={{
                                                    placeholder: 'Select Unit',
                                                    name: 'itemUnit',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="itemUnit"
                                                displayName={'name'}
                                                optionValue={'key'}
                                                isSubmit={isSubmit}
                                                value={formData.itemUnit || ''}
                                                options={unit}
                                                setValue={(e: any) => getValue(e)}
                                                errorMsg={errors?.itemUnit.message}
                                                inputProps={errors}
                                                type={'unit'}
                                                itemtype={itemtype}
                                                isDisabled={statusCompleted == 'completed'}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <MultiSelect
                                                    ref={childRef}
                                                    options={vendor}
                                                    placeholder={'Select User*'}
                                                    getMultiSelectValue={getMultiSelectValue}
                                                    displayName="name"
                                                    displayValue="id"
                                                    notSelectDefault={true}
                                                    // isDisabled={statusCompleted == 'completed' ? true : false}
                                                    isClearable={edit ? false : true}
                                                    setSelectedValues={formData.userIds || null}
                                                    isDisabled={statusCompleted == 'completed'}
                                                />

                                                {errors?.userIds?.required && errors?.userIds?.error && isSubmit && (
                                                    <div className="text-danger ft-12 error-msg">
                                                        {' '}
                                                        {errors?.userIds.message}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <CustomDateTimePicker
                                                    data={{
                                                        name: 'cutOffTime',
                                                        placeholder: 'Select Cut-Off Date & Time',
                                                        label: 'Cut Off Date',
                                                        type: 'datetime-local',
                                                        id: 'floatingInput',
                                                    }}
                                                    minDate={newDate24}
                                                    controlName="cutOffTime"
                                                    // disabled={statusCompleted == 'completed' ? true : false}
                                                    isSubmit={isSubmit}
                                                    value={formData?.cutOffTime !== null ? formData?.cutOffTime : ''}
                                                    setValue={(e: any) => {
                                                        // formData['deliveryDate'] = null;
                                                        // setFormData(formData);
                                                        // errors['deliveryDate']['error'] = true;
                                                        // setError(errors);
                                                        getValue(e);
                                                    }}
                                                    errorMsg={errors?.cutOffTime.message}
                                                    inputProps={errors}
                                                    fromType={'demand'}
                                                    dtype={'demand_cutoff_date'}
                                                    filterPassedTime={time => filterPassedTime(time, 'cutoff_date')}
                                                    disabled={statusCompleted == 'completed'}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: 'Enter Required Quality',
                                                        name: 'quality',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="quality"
                                                    isSubmit={isSubmit}
                                                    value={formData.quality}
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.quality.message}
                                                    inputProps={errors}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-12">
                                            {formData?.imageUrl != null ? (
                                                <>
                                                    {formData?.imageUrl == 'pdf' ? (
                                                        <div className="previewpdf">
                                                            {/* <img
                                                                src="./assets/images/pdficon.svg"
                                                                className="img-fluid"
                                                            /> */}
                                                            {edit ? (
                                                                <a
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    href={`${process.env.REACT_APP_API_BASE}${formData?.filename}`}
                                                                >
                                                                    <img
                                                                        src="./assets/images/pdficon.svg"
                                                                        className="img-fluid"
                                                                    />
                                                                </a>
                                                            ) : (
                                                                <img
                                                                    src="./assets/images/pdficon.svg"
                                                                    className="img-fluid"
                                                                />
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div className="previewimage">
                                                            <img
                                                                src={formData?.imageUrl}
                                                                className="img-fluid w-100 h-100"
                                                            />
                                                        </div>
                                                    )}
                                                    <br />
                                                </>
                                            ) : (
                                                ''
                                            )}

                                            <div
                                                className="drop-zone"
                                                onClick={() => {
                                                    document.getElementById('drop')?.click();
                                                }}
                                            >
                                                {formData?.filename != undefined ? (
                                                    <>
                                                        <span className="drop-zone__prompt">
                                                            <span className="material-symbols-outlined">upload</span>{' '}
                                                            Update the document(Max size: 5MB)
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span className="drop-zone__prompt">
                                                            <span className="material-symbols-outlined">upload</span>{' '}
                                                            Drop any attachment here(Max size: 5MB)
                                                        </span>
                                                    </>
                                                )}
                                                <input
                                                    type="file"
                                                    name="myFile"
                                                    className="drop-zone__input"
                                                    id="drop"
                                                    accept=".jpeg, .jpg, .png, .pdf"
                                                    onChange={e => {
                                                        handlefile(e.target.files, e);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div className="field_box">
                                    <h3>Additional Details</h3>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: 'Min Bid Rate (In Rs.)',
                                                        name: 'minBidRate',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="minBidRate"
                                                    isSubmit={isSubmit}
                                                    value={formData.minBidRate}
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.minBidRate.message}
                                                    inputProps={errors}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: 'Max Bid Rate (In Rs.)',
                                                        name: 'maxBidRate',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="maxBidRate"
                                                    isSubmit={isSubmit}
                                                    value={formData.maxBidRate}
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.maxBidRate.message}
                                                    inputProps={errors}
                                                />
                                                {minBidError && isSubmit && (
                                                    <div className="text-danger ft-12" style={{ marginTop: '-30px' }}>
                                                        {' '}
                                                        {'Max bid cannot be less then the min bid'}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <CustomDateTimePicker
                                                    data={{
                                                        name: 'deliveryDate',
                                                        placeholder: 'Select Delivery Date',
                                                        label: 'Delivery Date',
                                                        type: 'datetime-local',
                                                        id: 'floatingInput',
                                                    }}
                                                    // minDate={newDate48}
                                                    controlName="deliveryDate"
                                                    // disabled={statusCompleted == 'completed' ? true : false}
                                                    isSubmit={isSubmit}
                                                    value={
                                                        formData?.deliveryDate !== null ? formData?.deliveryDate : ''
                                                    }
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.deliveryDate.message}
                                                    inputProps={errors}
                                                    fromType={'demand'}
                                                    dtype={'demand_delivery_date'}
                                                    disabled={statusCompleted == 'completed' || disabledDeliveryDate}
                                                    selectDate={formData.cutOffTime}
                                                    minDate={formData.cutOffTime}
                                                    closeOnSelect={true}
                                                    makeEmpty={firstRender}
                                                    filterPassedTime={time => filterPassedTime(time, 'delivery_date')}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: 'Description',
                                                        name: 'description',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="description"
                                                    isSubmit={isSubmit}
                                                    value={formData?.description == 'null' ? '' : formData.description}
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.description.message}
                                                    inputProps={errors}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        {statusCompleted == 'completed' ? (
                            <></>
                        ) : (
                            <>
                                {/* {actionsPermissionValidator(location.pathname, ActionValues.Edit) ||
                                actionsPermissionValidator(location.pathname, ActionValues.Add) ? (
                                    <Button
                                        variant="secondary"
                                        className="btn dark_btn custom_btn"
                                        onClick={edit ? updateDemand_other : addDemand_other}
                                    >
                                        {edit ? 'Update' : 'Add'}
                                    </Button>
                                ) : (
                                    ''
                                )} */}
                                {actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                    <Button
                                        variant="secondary"
                                        className="btn dark_btn custom_btn"
                                        onClick={edit ? updateDemand_other : addDemand_other}
                                    >
                                        {edit ? 'Update' : 'Add'}
                                    </Button>
                                ) : actionsPermissionValidator(location.pathname, ActionValues.Add) && !edit ? (
                                    <Button
                                        variant="secondary"
                                        className="btn dark_btn custom_btn"
                                        onClick={edit ? updateDemand_other : addDemand_other}
                                    // disabled={disableUpdateBtn}
                                    >
                                        {'Add'}
                                    </Button>
                                ) : (
                                    ''
                                )}

                                <Button
                                    variant="default"
                                    className="btn custom_btn border_btn with_icon"
                                    onClick={() => {
                                        handlereset();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}
